import React from "react";
import { Helmet } from "react-helmet-async";
import { llmAnswerSchema } from "../../seo/llmAnswerSchema";

export default function LLMAnswerMetadata() {
  return (
    <Helmet>
      <script type="application/ld+json" id="pcp-llm-answer">
        {JSON.stringify(llmAnswerSchema).replace(/</g, "\\u003c")}
      </script>
    </Helmet>
  );
}
